"use strict";exports.__esModule=true;exports.default=void 0;var _default={"-":"",_:" ",0:"0"};exports.default=_default;